export const GET_PLANS = 'licensee/get-plans';
export const GET_PLANS_SUCCESS = 'licensee/get-plans-success';
export const GET_PLANS_FAIL = 'licensee/get-plans-fail';